module.exports = __webpack_public_path__ + "img/image28.39823486.jpeg";